<template>
  <div
    :class="`meetingItem ${itemData.status === 'CANCELADO' ? 'canceled' : ''} `"
  >
    <div class="meetingItem__left">
      <div class="meetingItem__imageBox">
        <PictureCircle :src="itemData.invited.image" />
      </div>
      <div class="meetingItem__info">
        <div
          class="meetingItem__info--name textOverflow"
          :title="beautifiedName"
        >
          {{ beautifiedName }}
        </div>
        <div class="meetingItem__info--texts textOverflow" :title="infoTexts">
          {{ infoTexts }}
        </div>
      </div>
    </div>
    <div class="meetingItem__right onlyOnHover">
      <div class="meetingItem__commonActions">
        <template v-for="({ click, label, to }, index) in commonActions">
          <Button
            :key="index"
            v-bind="{ to }"
            secondary
            class="meetingItem__action"
            :title="label"
            v-on="click ? { click } : {}"
          >
            <div class="textOverflow">
              {{ label }}
            </div>
          </Button>
        </template>
      </div>
      <button
        class="meetingItem__cancel"
        title="Cancelar atendimento"
        @click="cancelHandler"
      >
        <IconCancel />
      </button>
    </div>
  </div>
</template>

<script>
import PictureCircle from '@/components/PictureCircle';
import IconCancel from '@/assets/icon-cancel.svg';
import { mapActions, mapState, mapGetters } from 'vuex';
import { beautifyName } from '@/utils/beautifyNames';
import Button from '@/components/Button';

export default {
  name: 'MeetingItem',
  components: { PictureCircle, IconCancel, Button },

  props: {
    itemData: { type: Object, required: true },
  },

  computed: {
    ...mapState('dashboard', ['showModals']),
    ...mapGetters('dashboard', ['currWorkspace']),

    infoTexts() {
      const {
        itemData: { moment },
      } = this;
      const infos = `${moment.format('k:mm')}h`;

      return infos;
    },

    beautifiedName() {
      const { name } = this.itemData.invited;
      return beautifyName(name);
    },

    commonActions() {
      const { itemData } = this;

      return [
        {
          label: 'Ver histórico',
          to: `/patientHistory/${itemData.historyToken}`,
        },
        {
          label: 'Atender',
          to: `/treatments/${itemData.id}`,
        },
        {
          label: 'Reagendar',
          click: this.rescheduleHandler,
        },
      ];
    },
  },

  methods: {
    ...mapActions('dashboard', ['toggleModal']),
    ...mapActions('meeting', ['setThisAppointment', 'cancelThisAppointment']),

    rescheduleHandler() {
      const {
        itemData: { id, invited },
      } = this;
      const appointment = {
        id: id,
        patientName: invited.name,
      };
      this.setThisAppointment(appointment);
      this.toggleModal('newMedicalMeeting');
    },

    cancelHandler() {
      const {
        itemData: { id },
      } = this;
      const cancelMeetingItem = {
        id: id,
      };
      this.cancelThisAppointment(cancelMeetingItem.id);
      this.toggleModal('cancelMeeting');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
